import "./NursingCareProviderRehovot.module.css";
import Header from "@/reusable_sections/Header";
import NursingCaregiverInRehovotImmediateSolution from "./sections/NursingCaregiverInRehovotImmediateSolution";
import RelatedServicesCards from "./sections/RelatedServicesCards";
import RelatedServicesGrid from "./sections/RelatedServicesGrid";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import CtaBanner from "./sections/CtaBanner";
import Footer from "@/reusable_sections/Footer";
export default function NursingCareProviderRehovotPage() {
  return <div>
      <Header />
      <NursingCaregiverInRehovotImmediateSolution />
      <RelatedServicesCards />
      <RelatedServicesGrid />
      <FrequentlyAskedQuestions />
      <CtaBanner />
      <Footer />
    </div>;
}